import { useMutation, useQueryClient } from 'react-query';
import { queryKeys } from './queryKeys';
import { authFetch } from '../../../../../CommonUtils/authFetch';
import { urlWithParams } from '../../../../../CommonUtils/urlWithParams';

interface FetcherParams {
  clientId: string;
}

const resetToDefault = ({ clientId }: FetcherParams) => {
  return authFetch(
    urlWithParams('/Consumer/AssetBucketingLayoutUpdate/ResetDetails', { clientId }),
    { method: 'POST' },
  );
};

interface Params {
  clientId: string;
}

export const useResetToDefaultMutation = ({ clientId }: Params) => {
  const queryClient = useQueryClient();

  return useMutation(resetToDefault, {
    onSuccess() {
      queryClient.invalidateQueries(queryKeys.assetBucketDetails(clientId));
    },
  });
};
